import { Seo, StatusState } from '@/components/molecules';
import { PageIntro, Section } from '@/components/organisms';
import { useAccessoryOrderItems } from '@/hooks/useAccessoryOrderItems';

import { AccessoryCheckoutForm } from './organisms/AccessoryCheckoutForm';
import { AccessoryOrderLayout } from './organisms/AccessoryOrderLayout';

export default function AccessoryCheckoutPage() {
  const { entries } = useAccessoryOrderItems();

  return (
    <>
      <Seo
        title="Request an order"
        description="Send your shortlisted accessories to Kabex Motors and receive one order quotation."
        path="/accessories/checkout"
        noindex
      />
      <PageIntro
        eyebrow="Request an order"
        title="Ask for your order"
        lede="We'll send one quotation covering every part on your list. Nothing is paid or reserved here."
        keepOnPhone
      />
      <Section sx={{ py: { xs: 10, md: 16 } }}>
        {entries.length === 0 ? (
          <StatusState
            tone="empty"
            title="There are no parts on your list"
            description="Add the parts you would like to order, then come back."
            action={{ label: 'Browse accessories', to: '/accessories' }}
          />
        ) : (
          <AccessoryOrderLayout entries={entries}>
            <AccessoryCheckoutForm entries={entries} />
          </AccessoryOrderLayout>
        )}
      </Section>
    </>
  );
}